import {
    Feature,
    FEATURE_QUERY_VALUE,
    IFeatureQuery,
    IFeatureValue,
} from '@gig/magic-messages';
import VueRouter from 'vue-router';
import { RouteName } from '../../../routes/routes.constants';
import { ResponsibleGamingMenuTabs } from '@gig/magic-responsible-gaming-types';

export function initResponsibleGamingGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        const responsibleGamingTabsConfig = (
            await window.queryBus.query<IFeatureQuery, IFeatureValue>(
                FEATURE_QUERY_VALUE,
                {
                    slug: Feature.RESPONSIBLE_GAMING_FEATURES,
                    defaultValue: '',
                },
            )
        )?.value;

        const activeTabsRoutes =
            responsibleGamingTabsConfig.length > 0
                ? responsibleGamingTabsConfig
                      .split(',')
                      .map((item: string) => item.trim())
                : Object.values(ResponsibleGamingMenuTabs);

        // Replace LIMITS tab with the correct routes.
        if (activeTabsRoutes.indexOf('LIMITS') !== -1) {
            activeTabsRoutes.splice(activeTabsRoutes.indexOf('LIMITS'), 1);
            activeTabsRoutes.push('VIEW_LIMITS', 'CREATE_LIMITS');
        }
        // Active Responsible Gaming routes in the site
        const activeRPRoutes = [
            RouteName.VIEW_LIMITS,
            RouteName.CREATE_LIMITS,
            RouteName.REALITY_CHECK,
            RouteName.TIME_OUT,
            RouteName.SELF_EXCLUDE,
            RouteName.PLAY_CONTROL,
        ];
        const actualRoute = to.name;
        // Check if the actual route is allowed in the config and it is a Responsible Gaming route
        const checkAccessToRoute = (activeRoute: RouteName) =>
            // @ts-ignore
            RouteName[activeRoute] === actualRoute;
        const checkRPToRoute = (activeRoute: string) =>
            activeRoute === actualRoute;
        // Redirect to Responsible Gaming info page
        if (
            activeRPRoutes.some(checkRPToRoute) &&
            !activeTabsRoutes.some(checkAccessToRoute)
        ) {
            return next({
                name: RouteName.RESPONSIBLE_GAMING_PAGE,
            });
        }
        next();
    });
}
